import { render } from "./CurrencyDisplay.vue?vue&type=template&id=4f083672&scoped=true"
import script from "./CurrencyDisplay.vue?vue&type=script&lang=js"
export * from "./CurrencyDisplay.vue?vue&type=script&lang=js"

import "./CurrencyDisplay.vue?vue&type=style&index=0&id=4f083672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f083672"]])

export default __exports__